import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  studentSessionAnalyticsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  inactiveStudentDataAnalytcsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  tcUploadStudentDetailsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  tpVerificationTable: {
    loading: false,
    data: [],
    meta: {},
  },
  courseIncomeTable: {
    loading: false,
    data: [],
    meta: {},
  },
  croIndividualAccountsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  expiringAdmissionTable: {
    loading: false,
    data: [],
    meta: {},
  },

  departmentEmployeesTable: {
    loading: false,
    data: [],
    meta: {},
  },
  studentClassRestartDateTable: {
    loading: false,
    data: [],
    meta: {},
  },
  croPerfomanceAnalyticsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  croAnalyticsTable: {
    data: [],
    loading: false,
    meta: {},
  },
  coursePerfomanceAnalyticsTable: {
    data: [],
    loading: false,
    meta: {},
  },
  trainerMOUTable: {
    data: [],
    loading: false,
    meta: {},
  },
  paymentMethods: [],
  allTrainers: {
    data: [],
    loading: false,
  },
  loading: false,
  submitLoading: false,
  dailyNoAttendanceStudentsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  emiPaymentsTable: {
    loading: false,
    data: [],
    meta: {},
  },
};
// ======================THUNKS-----========================================

export const getStudentSessionAnalyticsTable = createAsyncThunk(
  'crdMigration/getStudentSessionAnalyticsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-student-session-analytics?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getInactiveStudentDataAnalytcsTable = createAsyncThunk(
  'crdMigration/getInactiveStudentDataAnalytcsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getTCUploadStudentDetailsTable = createAsyncThunk(
  'crdMigration/getTCUploadStudentDetailsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-tc-uploaded-student-details?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getTpVerificationTable = createAsyncThunk('crdMigration/getTpVerificationTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
  });
  return res;
});

export const getCourseIncomeTable = createAsyncThunk('crdMigration/getCourseIncomeTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-course-incomes?${searchParams.toString()}`,
  });
  return res;
});

export const getCroIndividualAccountsTable = createAsyncThunk(
  'crdMigration/getCroIndividualAccountsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-cro-indivitual-accounts?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getExpiringAdmissionTable = createAsyncThunk('crdMigration/getExpiringAdmission', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
  });
  return res;
});

// export const getDepartmentEmployeesTable = createAsyncThunk(
//   'crdMigration/getDepartmentEmployeesTable',
//   async (params) => {
//     const searchParams = new URLSearchParams(params);
//     const res = await apiRequest({
//       method: 'get',
//       url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
//     });
//     return res;
//   },
// );

export const getDepartmentEmployeesTable = createAsyncThunk(
  'crdMigration/getDepartmentEmployeesTable',
  async (params) => {
    const { page, limit, search, filters, departmentName } = params;

    const searchParams = new URLSearchParams({
      page,
      limit,
      search,
    });

    const res = await apiRequest({
      method: 'get',
      url: `users/all-users/?page=${page}&limit=${limit}&search=${search}&filters[department]=equals:${departmentName}`,
    });

    return res;
  },
);

export const getStudentClassRestartDateTable = createAsyncThunk(
  'crdMigration/getStudentClassRestartDateTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-student-restart-dates?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getCroPerfomanceAnalytics = createAsyncThunk('crdMigration/getCroPerfomanceAnalytics', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
  });
  return res;
});

export const getCroAnalyticsTable = createAsyncThunk('crdMigration/getCroAnalyticsTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-cro-analytics?${searchParams.toString()}`,
  });
  return res;
});

export const getCoursePerfomanceAnalytics = createAsyncThunk(
  'crdMigration/getCoursePerfomanceAnalytics',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-course-performace-analytics?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getPaymentMethods = createAsyncThunk('crdMigration/getPaymentMethods', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-payment-methods`,
  });
  return res;
});

export const getTrainerMOUTable = createAsyncThunk('crdMigration/getTrainerMOUTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-trainer-mou-details?${searchParams}`,
  });
  return res;
});

export const putTrainerMOUDetails = createAsyncThunk('crdMigration/putTrainerMOUDetails', async ({ data, id }) => {
  const res = await apiRequest({
    method: 'put',
    url: `crd-migrations/update-trainer-mou-details?trainer_mou_id=${id}`,
    data,
  });
  return res;
});
export const getTrainerWithSearch = createAsyncThunk('crdMigration/getTrainerWithSearch', async (search = null) => {
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-trainer-list?search=${search}`,
  });
  return res;
});

export const postTrainerMOUDetails = createAsyncThunk('crdMigration/postTrainerMOUDetails', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `crd-migrations/create-trainer-mou-details`,
    data,
  });
  return res;
});

export const getDailyNoAttendanceStudents = createAsyncThunk(
  'crdMigration/getDailyNoAttendanceStudents',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-daily-not-marked-attendance?${searchParams}`,
    });
    return res;
  },
);

export const getEmiPayments = createAsyncThunk('crdMigration/getEmiPayments', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `/crd-migrations/get-emi-payments?${searchParams}`, // ✅ FIXED: correct endpoint
  });
  return res;
});
// ===================----THUNKS----========================================

// ===================----SLICE----========================================

const crd_migration_slice = createSlice({
  name: 'crdMigration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //*************  student session Analytics ***********
    builder.addCase(getStudentSessionAnalyticsTable.pending, (state) => {
      state.studentSessionAnalyticsTable.loading = true;
    });
    builder.addCase(getStudentSessionAnalyticsTable.fulfilled, (state, action) => {
      state.studentSessionAnalyticsTable.loading = false;
      state.studentSessionAnalyticsTable.data = action.payload?.data;
      state.studentSessionAnalyticsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* Inactive Students Data Analytics *****
    builder.addCase(getInactiveStudentDataAnalytcsTable.pending, (state) => {
      state.inactiveStudentDataAnalytcsTable.loading = true;
    });
    builder.addCase(getInactiveStudentDataAnalytcsTable.fulfilled, (state, action) => {
      state.inactiveStudentDataAnalytcsTable.loading = false;
      state.inactiveStudentDataAnalytcsTable.data = action.payload?.data;
      state.inactiveStudentDataAnalytcsTable.meta = action.payload?.meta;
    });
    //****************************************************
    //************* student session Analytics ************

    //************* Tc Upoaded Student Details ************
    builder.addCase(getTCUploadStudentDetailsTable.pending, (state) => {
      state.tcUploadStudentDetailsTable.loading = true;
    });
    builder.addCase(getTCUploadStudentDetailsTable.fulfilled, (state, action) => {
      state.tcUploadStudentDetailsTable.loading = false;
      state.tcUploadStudentDetailsTable.data = action.payload?.data;
      state.tcUploadStudentDetailsTable.meta = action.payload?.meta;
    });
    //************* Tc Upoaded Student Details ************

    //************* Tp verification  ********************
    builder.addCase(getTpVerificationTable.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTpVerificationTable.fulfilled, (state, action) => {
      state.loading = false;
    });

    //************* Tp verification  ************************

    //************* Expiring Admissions  ************************

    builder.addCase(getExpiringAdmissionTable.pending, (state) => {
      state.expiringAdmissionTable.loading = true;
    });
    builder.addCase(getExpiringAdmissionTable.fulfilled, (state, action) => {
      state.expiringAdmissionTable.loading = false;
      state.expiringAdmissionTable.data = action.payload?.data;
      state.expiringAdmissionTable.meta = action.payload?.meta;
    });

    //************* Expiring Admissions  ************************

    //********* getCourseIncomeTable *****
    builder.addCase(getCourseIncomeTable.pending, (state) => {
      state.courseIncomeTable.loading = true;
    });
    builder.addCase(getCourseIncomeTable.fulfilled, (state, action) => {
      state.courseIncomeTable.loading = false;
      state.courseIncomeTable.data = action.payload?.data;
      state.courseIncomeTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* CroIndividualAccounts *****
    builder.addCase(getCroIndividualAccountsTable.pending, (state) => {
      state.croIndividualAccountsTable.loading = true;
    });
    builder.addCase(getCroIndividualAccountsTable.fulfilled, (state, action) => {
      state.croIndividualAccountsTable.loading = false;
      state.croIndividualAccountsTable.data = action.payload?.data;
      state.croIndividualAccountsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //**********************Department Employees******************************
    builder.addCase(getDepartmentEmployeesTable.pending, (state) => {
      state.departmentEmployeesTable.loading = true;
    });
    builder.addCase(getDepartmentEmployeesTable.fulfilled, (state, action) => {
      state.departmentEmployeesTable.loading = false;
      state.departmentEmployeesTable.data = action.payload?.data;
      state.departmentEmployeesTable.meta = action.payload?.meta;
    });

    //********* Student Class Restart Date *****
    builder.addCase(getStudentClassRestartDateTable.pending, (state) => {
      state.studentClassRestartDateTable.loading = true;
    });
    builder.addCase(getStudentClassRestartDateTable.fulfilled, (state, action) => {
      state.studentClassRestartDateTable.loading = false;
      state.studentClassRestartDateTable.data = action.payload?.data;
      state.studentClassRestartDateTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* CRO Perfomance Analytics *****
    builder.addCase(getCroPerfomanceAnalytics.pending, (state) => {
      state.croPerfomanceAnalyticsTable.loading = true;
    });
    builder.addCase(getCroPerfomanceAnalytics.fulfilled, (state, action) => {
      state.croPerfomanceAnalyticsTable.loading = false;
      state.croPerfomanceAnalyticsTable.data = action.payload?.data;
      state.croPerfomanceAnalyticsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* CRO Analytics *****
    builder.addCase(getCroAnalyticsTable.pending, (state) => {
      state.croAnalyticsTable.loading = true;
    });
    builder.addCase(getCroAnalyticsTable.fulfilled, (state, action) => {
      state.croAnalyticsTable.loading = false;
      state.croAnalyticsTable.data = action.payload?.data;
      state.croAnalyticsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* Course Perfomance Analytics *****
    builder.addCase(getCoursePerfomanceAnalytics.pending, (state) => {
      state.coursePerfomanceAnalyticsTable.loading = true;
    });
    builder.addCase(getCoursePerfomanceAnalytics.fulfilled, (state, action) => {
      state.coursePerfomanceAnalyticsTable.loading = false;
      state.coursePerfomanceAnalyticsTable.data = action.payload?.data;
      state.coursePerfomanceAnalyticsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* get Payment Methods *****
    builder.addCase(getPaymentMethods.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPaymentMethods.fulfilled, (state, action) => {
      state.loading = false;
      state.paymentMethods = action.payload?.data;
    });
    //****************************************************

    //********* Trainer MOU Details *****
    builder.addCase(getTrainerMOUTable.pending, (state) => {
      state.trainerMOUTable.loading = true;
    });
    builder.addCase(getTrainerMOUTable.fulfilled, (state, action) => {
      state.trainerMOUTable.loading = false;
      state.trainerMOUTable.data = action.payload?.data;
      state.trainerMOUTable.meta = action.payload?.meta;
    });
    //****************************************************
    //********* put trainer MOU Details *****
    builder.addCase(putTrainerMOUDetails.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(putTrainerMOUDetails.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************

    //********* get Trainer with Search *****
    builder.addCase(getTrainerWithSearch.pending, (state) => {
      state.allTrainers.loading = true;
    });
    builder.addCase(getTrainerWithSearch.fulfilled, (state, action) => {
      state.allTrainers.loading = false;
      state.allTrainers.data = action.payload?.data;
    });
    //****************************************************

    //********* post trainer MOU Details *****
    builder.addCase(postTrainerMOUDetails.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(postTrainerMOUDetails.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************
    //********* Daily attendance students *****
    builder.addCase(getDailyNoAttendanceStudents.pending, (state) => {
      state.dailyNoAttendanceStudentsTable.loading = true;
    });
    builder.addCase(getDailyNoAttendanceStudents.fulfilled, (state, action) => {
      state.dailyNoAttendanceStudentsTable.loading = false;
      state.dailyNoAttendanceStudentsTable.data = action.payload?.data;
      state.dailyNoAttendanceStudentsTable.meta = action.payload?.meta;
    });
    //****************************************************
    //********* emi payments *****
    builder.addCase(getEmiPayments.pending, (state) => {
      state.emiPaymentsTable.loading = true;
    });
    builder.addCase(getEmiPayments.fulfilled, (state, action) => {
      state.emiPaymentsTable.loading = false;
      state.emiPaymentsTable.data = action.payload?.data;
      state.emiPaymentsTable.meta = action.payload?.meta;
    });
    //****************************************************
  },
});

export const crdMigrationSlice = crd_migration_slice.reducer;
